import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { Submenu } from '../../comps/Submenu';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { DataviewStore } from '../../stores/DataviewStore';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'/creationTimestamp :datetime',
	'/timestamp :datetime',
	'/supplierItem_itemNo =itemNo',
	'/supplierItem_name =name',
	'/supplierItem_packaging =packaging',
	'/supplierItem_eancode =eancode',
	'/isDeleted :bool',
	'/isAllowed :bool',
	'/isInitial :bool',
]);

const dataviewStore = DataviewStore.create({
	id: 'AdmTemplateItemPage',
	orgColumns: columnist.descriptors,
});

interface IAdmTemplateItemDialogProps {
	columnist: MgColumnist
	entity?: object
	onClose() : void
}

const AdmTemplateItemDialog = observer(function AdmTemplateItemDialog(props: IAdmTemplateItemDialogProps) {
	const {columnist, entity, onClose} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, string>;
	return <MgEntityEditDialog
		columnist={columnist}
		extras={columnist.newExtras(editable, {})}
		entity={editable}
		baseName="AdmTemplateItemDialog"
		finish={onClose}
		readonly
	/>;
});

export const AdmTemplateItemPage = observer(function AdmTemplateItemPage() {
	const omnistore = useOmnistore();
	const pretemplateId = omnistore.locationStore.pretemplateId;
	const repo = omnistore.multirepo.templateItemRepo(pretemplateId);
	React.useEffect(() => {
		if (pretemplateId) repo.fetch();
	}, [pretemplateId]);
	useNoSubmenu();
	const onDialogClose = () => dataviewStore.rowClick(0);
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			---
		</Submenu>
		{!pretemplateId ? null : <OcDataview state={dataviewStore} repo={repo}/>}
		{!selectedEntity ? null : <AdmTemplateItemDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose}/>}
	</>;
});
